import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es muy caro hacer esta dieta?',
    a: 'No, está diseñada para ser más barata que un mercado tradicional de carbohidratos.'
  }, {
    q: '¿Tengo que cocinar mucho?',
    a: 'No, las recetas se preparan en menos de 15 minutos.'
  }, {
    q: '¿Puedo comer chicharrón?',
    a: 'Sí, es uno de los pilares del plan si se consume correctamente.'
  }, {
    q: '¿Sirve para alguien que almuerza en la calle?',
    a: 'Totalmente, incluimos una sección dedicada a pedir en el "corrientazo".'
  }, {
    q: '¿Cómo recibo el producto?',
    a: 'Directo a tu correo electrónico tras el pago seguro.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-[#FAFAF5] text-[#1A1A1A] py-16 md:py-24 px-4" data-id="element-24">
      <div className="max-w-3xl mx-auto" data-id="element-25">
        <h2 className="font-montserrat font-black text-3xl md:text-4xl text-center mb-12 uppercase" data-id="element-26">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-27">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-2xl overflow-hidden transition-all duration-300" data-id="element-28">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-29">
                <span className="font-montserrat font-bold text-lg md:text-xl text-[#1A1A1A] pr-4" data-id="element-30">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-[#F5C518] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-31" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-32">
                <p className="font-inter text-gray-600 text-lg" data-id="element-33">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}